import { definePage } from "@openclaw/uirouter";
import { html } from "lit";
import { routePageSpec } from "../../app-route-paths.ts";

export const page = definePage({
  ...routePageSpec("connection"),
  component: () =>
    import("./connection-page.ts").then(() => ({
      header: true,
      render: () => html`<openclaw-connection-page></openclaw-connection-page>`,
    })),
});
